<template>
   <v-container>
     <div itemscope itemtype="http://schema.org/Product">
     <v-layout row wrap>
       <v-flex xs12>
         <v-card >
           <div itemprop="image">
           <v-card-media
             class="edomargintop"
             height="450px"
             alt="examenis"
             :src="require('../assets/examenis.jpg')">
             <v-container fill-height>
               <v-layout fill-height>
                 <v-flex xs12 align-end flexbox>
                   <div class="edoschriftzentriertexamenis abstand">
                   <div class="edologobildexamenis"> <img src="../assets/examenis_logo.svg"/>
                   </div>
                   <span class="examenisbildtext">erstellen, durchführen, analysieren</span>
                   </div>
                 </v-flex>
               </v-layout>
             </v-container>
           </v-card-media>
           </div>
         </v-card>
       </v-flex>
     </v-layout>

     <div>
       <v-breadcrumbs divider=">" class="edobread">
         <v-breadcrumbs-item
           v-for="item in items"
           :key="item.text"
           :disabled="item.disabled"
         >
           <a :href='item.route'>{{ item.text }}</a>
         </v-breadcrumbs-item>
       </v-breadcrumbs>
     </div>

       <v-container fluid grid-list-md>
         <v-layout row justify-space-around>
           <v-flex d-flex xs12 sm10 md10>
             <v-card class="edomargintop" flat>
               <v-card-title primary class="title edoheadlinetext">
                 <span itemprop="name">
                 <span style="color: #4465ad"> Examenis – <br> die intelligente Softwarelösung für moderne Prüfungen und Umfragen</span>
                 </span>
               </v-card-title>
               <v-card-text class="edoLineText">
                 <span itemprop="description">
                 Es war noch nie so einfach und effizient Prüfungen und Umfragen zu erstellen und auszuwerten.

                 examenis bietet Ihnen die Möglichkeit online über den Browser oder offline auf einem lokalen Rechner zu arbeiten.
                 <br><br>
                 Selbst papierbasierte Ausführungen können, dank Scanner-Schnittstelle erfasst und analysiert werden. examenis offeriert Ihnen ein breites Spektrum an Fähigkeiten Fragen zu implementieren. Single- und Multiple Choice-Fragen bilden im System die Basis von Zuordnungs-, Umordnungs- und Vergleichsaufgaben. Im Bereich freier Beantwortung sind Ergänzungs-, Begriffs- und Textaufagben möglich.
                 <br><br>
                 Die ökonomische Filterfunktion hilft Ihnen dabei Ihre archivierten und aktuellen Dokumente schneller und einfacher zu finden.
                 <br><br>
                 Durch examenis haben Sie keinerlei Datenverluste mehr, denn die gesamten Daten werden auf digitaler Ebene archiviert und sind zu jeder Zeit abrufbar. Die bedienerfreundliche Oberfläche erleichtert Ihnen das Arbeiten und ist somit ein weiterer Vorteil in der Erstellung und Auswertung von Prüfungsaufgaben.
                 </span>
               </v-card-text>
             </v-card>
           </v-flex>
         </v-layout>
       </v-container>
     </div>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex xs12 sm10 md10>
           <v-card>
             <v-card-media
               class="edomargintop"
               height="400px"
               :src="require('../assets/examenis_image.jpg')">
             </v-card-media>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex d-flex xs12 sm8 md8>
           <v-card class="edomargintop" flat>
             <div class="myvCardTitle">
               Starten Sie jetzt in das moderne<br> Prüfungs- und Umfrage-Zeitalter–<br>
               es war noch nie so einfach.
             </div>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm9 md9>
           <v-card class="edomargintop" flat>
             <div itemprop="email" itemscope itemtype="http://schema.org/PostalAddress">
             <div class="text-xs-center edomargintop">
               <v-btn outline color="grey darken-3" @click="mailto" class="linkedo">
                 <a href="mailto:info@edologic.de" itemprop="email">
                 Mehr Informationen per Mail erhalten
                 </a>
               </v-btn>
             </div>
             </div>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-layout row wrap>
       <v-container>
         <v-card class="edoabstandfooter">
         </v-card>
       </v-container>
     </v-layout>

     <v-container fluid grid-list-md>
       <div itemscope itemtype="http://schema.org/DownloadAction">
       <v-layout row  wrap justify-space-around>
         <v-flex d-flex xs12 sm8 md8>
           <v-card class="edomargintop" flat>
             <div class="myvCardTitle link">
               <span itemprop="description">
               <a download="examenis.pdf" href="/static/examenis.pdf" title="examenis Broschuere">
               Nützliche Infos finden Sie in unserer Broschüre. <br>
               Hier herunterladen: <br><br>
                 <img alt="examenis Broschuere" src="/static/examenis_pdf_icon.jpg">
               </a>
               </span>
             </div>
           </v-card>
         </v-flex>
       </v-layout>
       </div>
     </v-container>

     <v-layout row wrap>
       <v-container>
         <v-card class="edoabstandfooter" flat>
         </v-card>
       </v-container>
     </v-layout>
     </v-container>
</template>

<script>
  export default {
    name: 'Examenis',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Examenis – das Prüfungsprogramm',
      meta: [
        {
          name: 'description',
          content: 'Das Programm um Prüfungen und Umfragen zu automatisieren – mit wenigen Klicks zum Erfolg.'
        }]
    },
    data: () => ({
      items: [
        {
          text: 'Home',
          route: '/home',
          disabled: false
        },
        {
          text: 'Produkte',
          route: '/produkte',
          disabled: false
        },
        {
          text: 'examenis',
          route: '',
          disabled: true
        }
      ]
    }),
    methods: {
      mailto () {
        window.location = 'mailto:info@edologic.de'
      }
    },
    mounted () {
      console.log('Examenis')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Examenis.vue